import { render, staticRenderFns } from "./SendMessageHistoryTable.vue?vue&type=template&id=73fdef90&scoped=true&lang=pug"
import script from "./SendMessageHistoryTable.vue?vue&type=script&lang=ts"
export * from "./SendMessageHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageHistoryTable.vue?vue&type=style&index=0&id=73fdef90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdef90",
  null
  
)

export default component.exports